"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shapes = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["icon", "content", "className", "boxShadow", "buttonClassName"],
    _excluded2 = ["icon", "content", "className", "buttonClassName", "boxShadow"],
    _excluded3 = ["icon", "className", "boxShadow", "buttonClassName"],
    _excluded4 = ["icon", "className", "buttonClassName", "boxShadow"],
    _excluded5 = ["icon", "content", "className", "boxShadow", "buttonClassName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonFull = function ButtonFull(_ref) {
  var icon = _ref.icon,
      content = _ref.content,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      boxShadow = _ref.boxShadow,
      _ref$buttonClassName = _ref.buttonClassName,
      buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement("a", _extends({}, props, {
    className: "share-button--full ".concat(boxShadow ? 'share-button--box-shadowed' : '', " ").concat(buttonClassName, " ").concat(className)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-button--full-icon-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    className: "share-button--icon"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "share-button--text"
  }, content));
};

var ButtonMinimal = function ButtonMinimal(_ref2) {
  var icon = _ref2.icon,
      content = _ref2.content,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$buttonClassName = _ref2.buttonClassName,
      buttonClassName = _ref2$buttonClassName === void 0 ? '' : _ref2$buttonClassName,
      _ = _ref2.boxShadow,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement("a", _extends({}, props, {
    className: "share-button--minimal ".concat(buttonClassName, " ").concat(className)
  }), /*#__PURE__*/_react["default"].createElement(Icon, {
    className: "share-button--icon"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "share-button--text"
  }, content));
};

var ButtonRound = function ButtonRound(_ref3) {
  var icon = _ref3.icon,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      boxShadow = _ref3.boxShadow,
      _ref3$buttonClassName = _ref3.buttonClassName,
      buttonClassName = _ref3$buttonClassName === void 0 ? '' : _ref3$buttonClassName,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement("a", _extends({}, props, {
    className: "share-button--round ".concat(boxShadow ? 'share-button--box-shadowed' : '', " ").concat(buttonClassName, " ").concat(className)
  }), /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var ButtonSquare = function ButtonSquare(_ref4) {
  var icon = _ref4.icon,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      _ref4$buttonClassName = _ref4.buttonClassName,
      buttonClassName = _ref4$buttonClassName === void 0 ? '' : _ref4$buttonClassName,
      _ = _ref4.boxShadow,
      props = _objectWithoutProperties(_ref4, _excluded4);

  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement("a", _extends({}, props, {
    className: "share-button--square ".concat(buttonClassName, " ").concat(className)
  }), /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var ButtonRoundWithLabel = function ButtonRoundWithLabel(_ref5) {
  var icon = _ref5.icon,
      content = _ref5.content,
      _ref5$className = _ref5.className,
      className = _ref5$className === void 0 ? '' : _ref5$className,
      boxShadow = _ref5.boxShadow,
      _ref5$buttonClassName = _ref5.buttonClassName,
      buttonClassName = _ref5$buttonClassName === void 0 ? '' : _ref5$buttonClassName,
      props = _objectWithoutProperties(_ref5, _excluded5);

  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "share-button--round-with-label ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("a", _extends({}, props, {
    className: "share-button--round ".concat(boxShadow ? 'share-button--box-shadowed' : '', " ").concat(buttonClassName)
  }), /*#__PURE__*/_react["default"].createElement(Icon, null)), content);
};

var shapes = {
  full: ButtonFull,
  minimal: ButtonMinimal,
  round: ButtonRound,
  square: ButtonSquare,
  roundWithLabel: ButtonRoundWithLabel
};
exports.shapes = shapes;